import { baseQuery } from '../baseQuery';
import { type JsonDataItem } from 'types';

export const getRescheduleAppointments = async ({
  startDate,
  jobId,
  serviceType,
  daysAmount,
  techIds,
  surroundingGeeks,
  skillIds,
  duration,
}: JsonDataItem) => {
  const skills = skillIds?.length ? skillIds.map((id: number) => `&skill_ID[]=${id}`).join('') : '';
  const techs = techIds?.length ? techIds.map((id: number) => `&technician_ID[]=${id}`).join('') : '';

  const data = await baseQuery(
    `reschedule-appointments?appointment_date=${startDate}&service_id=${jobId}&no_of_days=${daysAmount}&service_type=${serviceType}${techs}${skills}&surrounding_suburbs=${surroundingGeeks}&duration=${duration}`,
  );

  return data;
};
